import { AppSystem, IPage } from '../../interfaces';

export const addPagesAppSystem = (pages: IPage[], system: AppSystem): IPage[] => {
    return pages.map((i: IPage) => ({
        ...i,
        appSystem: system,
        subMenu: i.subMenu && i.subMenu.length ? addPagesAppSystem(i.subMenu, system) : undefined,
    }));
};
